import { useGetParams } from '../../hooks/useGetParams';
import styles from './Variant.module.css';
import { motion, scale } from 'framer-motion';

export const Variant = ({ item, index, isQuestionImg, aciveAmimate }) => {
  const { answerFontSize, varNumFontSize } = useGetParams();

  // анимация правильного варианта
  const titleVariants = {
    inactive: {
      color: '#102756',
      backgroundColor: '#ffffff',
    },
    active: {
      color: '#ffffff',
      backgroundColor: '#0DCD12',
    },
  };

  const numberVariants = {
    inactive: {
      backgroundColor: '#0022f8',
    },
    active: {
      backgroundColor: '#0DCD12',
    },
  };

  const variant = {
    inactive: {
      scale: 1,
      transformOrigin: '10% 50%',
      transition: { duration: 0.5 },
    },
    active: {
      transformOrigin: '10% 50%',
      scale: [1, 1.2, 1, 1.2],
    },
  };

  return (
    <motion.div
      variants={variant}
      initial="inactive"
      animate={aciveAmimate ? 'active' : 'inactive'}
      transition={{ duration: 2, times: [0, 0.33, 0.66, 1], ease: 'easeInOut' }}
      className={styles.variant}
      style={{
        minHeight: isQuestionImg ? 'none' : '20rem',
      }}
    >
      <motion.div
        variants={numberVariants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
        transition={{ duration: 1 }}
        className={styles.varNumber}
        style={{
          fontSize: `${varNumFontSize}rem`,
          lineHeight: `${varNumFontSize}rem`,
          height: `${1.3 * varNumFontSize}rem`,
          minWidth: `${1.3 * varNumFontSize}rem`,
        }}
      >
        {index + 1}
      </motion.div>
      <motion.div
        variants={titleVariants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
        transition={{ duration: 1 }}
        className={styles.varTitle}
        style={{
          fontSize: `${answerFontSize}rem`,
          lineHeight: `${answerFontSize}rem`,
          maxWidth: isQuestionImg ? '78rem' : '50rem',
          minHeight: `${1.3 * varNumFontSize}rem`,
        }}
      >
        {item.comment}
      </motion.div>
    </motion.div>
  );
};
